<template>
    <v-app>
        <app-autenticacao />
        <AppCarregando />
        <AppMensagem />
        <v-main>
            <router-view />
        </v-main>
        <Menu
            :titulo="
                this.$route.meta.tituloMenu === undefined
                    ? titulo
                    : this.$route.meta.tituloMenu
            "
        />
    </v-app>
</template>

<script>
import AppCarregando from "@universidade-franciscana/componente-front/src/components/comuns/AppCarregando.vue"
import AppMensagem from "@universidade-franciscana/componente-front/src/components/comuns/AppMensagem.vue"
import AppAutenticacao from "@universidade-franciscana/componente-front/src/components/comuns/AppAutenticacao.vue"
import Menu from "@universidade-franciscana/componente-front/src/views/Menu.vue"

export default {
  name: "App",

  components: {
    AppCarregando,
    AppMensagem,
    AppAutenticacao,
    // eslint-disable-next-line vue/no-reserved-component-names
    Menu,
  },

  data: () => ({
    titulo: "Acadêmico",
  }),
  mounted() {
  },
}
</script>

<style>

.combo-cursos {
  display: grid;
  border-radius: 4px;
  border: 1px solid #eee;
  padding: 4px;
  margin: 4px;
}
</style>
